module.exports = __webpack_public_path__ + "static/media/eagleTakesChild.f9ad0736.jpg";